// extracted by mini-css-extract-plugin
module.exports = {"picture":"_30ZQFp","image":"_1nFgxw","fullWidth":"_3EYr91","fullHeight":"_3VhM_s"};